import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateChallengeTitleV1Request } from './update-challenge-title-v1-request';
import type { IUpdateChallengeTitleV1Response } from './update-challenge-title-v1-response';
import { updateChallengeTitleV1ResponseSchema } from './update-challenge-title-v1-response';

export async function updateChallengeTitleV1Api({
  id,
  body,
}: IUpdateChallengeTitleV1Request): Promise<IValidatedResponse<IUpdateChallengeTitleV1Response>> {
  return putRequest<IUpdateChallengeTitleV1Response>({
    path: `/sys/challenges/${id}/title/v1`,
    body,
    schema: updateChallengeTitleV1ResponseSchema,
  });
}
